import request from '@/utils/request'


export function getEducationPlanMaster(param, isNotify) {
  return request({
    url: `/api/getEducationPlanMaster`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function getEducationPlanDetail(param, isNotify) {
  return request({
    url: `/api/getEducationPlanDetail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function getUserWithClient(param, isNotify) {
  return request({
    url: `/api/getUserWithClient`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}


export function saveEducationPlan(param, isNotify) {
  return request({
    url: `/api/saveEducationPlan`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'saved' },
  })
}

export function deleteEducationPlanMaster(param, isNotify) {
  return request({
    url: `/api/deleteEducationPlanMaster`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'deleted' },
  })
}

export function getEducationTeacher(param, isNotify) {
  return request({
    url: `/api/getEducationTeacher`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
  })
}

export function getEducationPlanReport(param, isNotify) {
  let responseType = "blob"
  return request({
    url: `/api/getEducationPlanReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'searched' },
    responseType: responseType
  })
}

export function sendEducationFcm(param, isNotify) {
  return request({
    url: `/api/sendEducationFcm`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'sended' },
  })
}

export function getEducationType(param, isNotify) {
  return request({
    url: `/api/getEducationType`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'sended' },
  })
}

// 근로자 확인
export function checkEducationPlan(param, isNotify) {
  return request({
    url: `/api/m/checkEducationPlan`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    Notify: { use: isNotify, apitype: 'sended' },
  })
}